import FormInput from './Input.vue';

export * from './types';
export default FormInput;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/input/index.ts